
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5136fd87&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BootstrapModal.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BootstrapModal.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-5136fd87!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BootstrapModal.vue"),
  /* scopeId */
  "data-v-5136fd87",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/fragment/BootstrapModal.vue
// module id = 14
// module chunks = 2 3